import React from 'react';

import { Box, Typography } from '@material-ui/core';
import Checkbox from 'components/V2/Checkbox';
import PropTypes from 'prop-types';
import { SSN_CONFIGURATION_TYPES } from 'views/V2/Workflow/constants';

import styles from '../../userInformation.module.css';

const PartialSsnFallback = ({ onFallbackChange, isFallbackAlreadyAdded }) => {
    return (
        <Box className={styles.fallback_container}>
            <Box>
                <Typography className={styles.fallback_heading}>Fallback:</Typography>
                <Typography className={styles.fallback_sub_text}>
                    If verification fails with a partial SSN, users may be prompted to enter their
                    full SSN.
                </Typography>
            </Box>
            <Box className={styles.ssn_fallback_container}>
                <Box className={styles.fallback_ssn_options}>
                    <Typography className={styles.fallback_ssn_option_text}>
                        Success: <strong>Highest using Full SSN</strong>
                    </Typography>
                </Box>
                <Box className={styles.fallback_ssn_options}>
                    <Typography className={styles.fallback_ssn_option_text}>
                        Request Full SSN
                    </Typography>
                    <Checkbox
                        checked={isFallbackAlreadyAdded(SSN_CONFIGURATION_TYPES.COLLECT_FULL_SSN)}
                        onChange={() => onFallbackChange(SSN_CONFIGURATION_TYPES.COLLECT_FULL_SSN)}
                    />
                </Box>
            </Box>
        </Box>
    );
};

PartialSsnFallback.propTypes = {
    onFallbackChange: PropTypes.func,
    isFallbackAlreadyAdded: PropTypes.func,
};

export default PartialSsnFallback;
